// Génération locale adaptée de E-timbre/src/infra/pdf/timbre.ts (qrcode, correction M).
// Le contenu est ici l'URI TOTP de CollectivitésConnect, jamais envoyé à un service de QR externe.
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

export function CodeQrMfa({ uri }: { uri: string }) {
  const [image, setImage] = useState<string | null>(null);
  const [echec, setEchec] = useState(false);

  useEffect(() => {
    let actif = true;
    setImage(null);
    setEchec(false);
    void QRCode.toDataURL(uri, {
      width: 256,
      margin: 4,
      errorCorrectionLevel: 'M',
      color: { dark: '#000000', light: '#ffffff' },
    })
      .then((donnees) => {
        if (actif) setImage(donnees);
      })
      .catch(() => {
        if (actif) setEchec(true);
      });
    return () => {
      actif = false;
    };
  }, [uri]);

  if (echec)
    return (
      <p role="status">
        Le code QR ne peut pas être affiché. Utilisez la clé de saisie manuelle ci-dessous.
      </p>
    );
  if (!image) return <p role="status">Préparation du code QR…</p>;
  return (
    <img
      src={image}
      width={256}
      height={256}
      style={{ maxWidth: '100%', height: 'auto' }}
      alt="Code QR à scanner dans votre application d’authentification"
    />
  );
}
